export default __webpack_public_path__ + "f36aafc24aa600a5fe805819b4b36bf8.png";